import { getCookie } from 'cookies-next'

export const MIDDLEWARE_AUTH_COOKIE = 'isAuthenticated'

/**
 * Whether middleware considers the user logged in (non-httpOnly cookie mirrors access-token presence).
 * Use this before calling authenticated-only APIs from the client — see UserContext.fetchUser.
 */
export function isAuthenticatedViaMiddlewareCookie(): boolean {
    return getCookie(MIDDLEWARE_AUTH_COOKIE) === 'true'
}
